import { useSyncExternalStore } from 'react'

/**
 * Skrytie karty „Ako začať“ - pamätá si ho prehliadač. Zdieľané medzi kartou
 * nad kalendárom a ikonkou v hlavičke, ktorá ju vráti späť.
 */
const HIDE_KEY = 'l2s:onboarding-hidden'
const listeners = new Set<() => void>()

function read() {
  try {
    return window.localStorage.getItem(HIDE_KEY) === '1'
  } catch {
    return false
  }
}

let current = read()

export function setOnboardingHidden(value: boolean) {
  try {
    if (value) window.localStorage.setItem(HIDE_KEY, '1')
    else window.localStorage.removeItem(HIDE_KEY)
  } catch {
    // bez úložiska platí zmena len do obnovenia stránky
  }
  current = value
  listeners.forEach((listener) => listener())
}

export function useOnboardingHidden() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => current,
  )
}
